import { createContext, useContext, useState } from "react";
import getSearch from '../services/getSearch';
const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
    const [city, setCity] = useState("");
    const [tag, setTag] = useState("");
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [guests, setGuests] = useState(1);
    const [searchResults, setSearchResults] = useState([]);
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleSearch = async (params) => {
        try {
            setLoading(true);
            setCity(params.city || "")
            setCheckIn(params.checkIn || "")
            setCheckOut(params.checkOut || "")
            setGuests(params.guests || 1)
            setTag(params.tag || "")

            const results = await getSearch(params);

            if (results) {
                if (results.length == 0) {
                    setLoading(false);
                }
                setSearchResults([...results]);
                return results
            } else {
                setSearchResults([]);
                return []
            }
        } catch (error) {
            console.error("Error en la búsqueda:", error);
            setSearchResults([]);
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    };

    return (
        <SearchContext.Provider value={{ city, setCity, tag, setTag, tags, setTags, checkIn, setCheckIn, checkOut, setCheckOut, guests, setGuests, handleSearch, searchResults, loading, setLoading }}>
            {children}
        </SearchContext.Provider>
    );
};

export const useSearch = () => useContext(SearchContext);
